require('./collectiveLandingFAQ.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

class CollectivesFAQs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            expandedId : ''
        }
        this.handleOnClick = this.handleOnClick.bind(this);
    }

    handleOnClick(isExpanded, index) {
        let id = '';
        if (isExpanded) {
            id = index;
        }
        this.setState({
            expandedId: id
        })
    }

    renderFAQs(FAQData) {
        const FAQs = FAQData && FAQData.map((content, index) => {
            const accordionHeaderContent = (
                <HTMLSafeInjector
                    message={formatText(content.question)}
                />
            );
            const accordionBodyContent = (
                <HTMLSafeInjector
                    message={formatText(content.answer)}
                />
            );
            let isExpanded = false;
            if(index === this.state.expandedId) {
                isExpanded = true;
            }

            return (
                <Accordion
                    customClassName="collectives-faq__accordion "
                    id={index}
                    onClick={this.handleOnClick}
                    isExpanded={isExpanded}
                    allowSingleExpand={true}
                    key={index}
                >
                    <AccordionHeader id={index} isExpanded={isExpanded} isRightArrowPosition={true} name="AccordionHeader">
                        {accordionHeaderContent}
                    </AccordionHeader>
                    <AccordionBody isExpanded={isExpanded} name="AccordionBody">{accordionBodyContent}</AccordionBody>
                </Accordion>
            );
        })
        return FAQs;
    }

    render() {
        const { FAQData } = this.props;
        const FAQs = this.renderFAQs(FAQData);

        return (
            <section
                className="collectives-faq"
            >
                <div className="collectives-faq__title">
                    <FormattedText value="colectivesLanding-colectivesLanding_faqTitle" />
                </div>
                <div className="collectives-faq__list">{FAQs}</div>
            </section>
        )
    }
}

CollectivesFAQs.propTypes = {
    FAQData: PropTypes.object.isRequired
};

module.exports = CollectivesFAQs;
